// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AdjustFareFooter from "./AdjustFareFooter.bs.js";
import * as OrderFareDetails from "./OrderFareDetails.bs.js";

function AdjustFareDetailsSection(Props) {
  var currency_symbol = Props.currency_symbol;
  var current_fare_details = Props.current_fare_details;
  var new_fare_details = Props.new_fare_details;
  var state = Props.state;
  var dispatch = Props.dispatch;
  return React.createElement("div", {
              className: "c-adjust-fare-details-container"
            }, React.createElement(OrderFareDetails.make, {
                  crn: new_fare_details.data.crn,
                  currency_symbol: currency_symbol,
                  fare_info: new_fare_details.data.order_fare
                }), React.createElement(AdjustFareFooter.make, {
                  currency_symbol: currency_symbol,
                  current_fare_details: current_fare_details,
                  new_fare_details: new_fare_details,
                  form_duration_selector: state.form_duration_selector,
                  is_submit_button_enabled: state.is_submit_button_enabled,
                  dispatch: dispatch
                }));
}

var make = AdjustFareDetailsSection;

export {
  make ,
  
}
/* react Not a pure module */
